import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImprestDetails, IRequest } from '../models/request.model';
import { MatTableModule } from '@angular/material/table';
import { NgIf, DecimalPipe, DatePipe, CommonModule } from '@angular/common';
import { toWords } from 'number-to-words';
import { NextPage } from '@cvx/nextpage';
import { ApprovalRouteComponent } from "../approval-route/approval-route.component";
import { RequestHistoryComponent } from "../request-history/request-history.component";
import { SearchRequestService } from '../services/search-request.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { PersonSearchComponent } from '../../shared/person-search/person-search.component';
import { IPerson } from '../../models/person.model';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SearchRequestValidator } from '../search-request/search-request.validator';
import { RequestStatuses, requestStatusesMapping } from '../models/request-status.model';
import { IApprovalRoute } from '../models/approval-route.model';
import { MatRadioModule } from '@angular/material/radio';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { IRequestTerminate } from '../models/request-terminate.model';
import { IRequestReady } from '../models/request-ready.model';
import { HowPaid } from '../../shared/constants/how-paid.enum';
import { Mode } from '../../shared/constants/mode.enum';
import { UserRole } from '../../shared/constants/user-role.enum';
import { RequestOperation } from '../../shared/constants/request-operation.enum';
import { IRequestReturn } from '../models/request-return.model';
import { PersonService } from '../../services/common/person.service';
import { CurrencyService } from '../../services/common/currency.service';
import { NmaDoaService } from '../../services/common/nmaDoa.service';
import { IRequestApprove } from '../models/request-approve.model';
import { IRequestSendToJde } from '../models/request-send-to-jde.model';
import { firstValueFrom } from 'rxjs';
import { BlobModel } from '../models/blob.model';

@Component({
  selector: 'app-request-details-view',
  standalone: true,
  imports: [
    MatDialogModule, 
    MatTableModule, 
    NgIf,     
    NextPage, 
    ApprovalRouteComponent, 
    RequestHistoryComponent, 
    DecimalPipe, 
    MatProgressSpinnerModule, 
    MatTabsModule, 
    CommonModule,
    PersonSearchComponent,
    MatRadioModule, 
    ReactiveFormsModule],
  templateUrl: './request-details-view.component.html',
  styleUrl: './request-details-view.component.scss',
  providers: [DatePipe]
})
export class RequestDetailsViewComponent implements OnInit {
  public requestOperation: typeof RequestOperation = RequestOperation;
  requestNumber: number;
  isLoading = true;
  historyDataLoaded: Boolean = false;
  form: FormGroup;
  label = "";
  placeholder = "";
  endInformation = "";

  requestData: IRequest;
  approvalRouteData: IApprovalRoute[];
  pendingApprovalRouteData: IApprovalRoute[];
  imprestDetails: ImprestDetails[] = [];
  attachments: BlobModel[] = [];
  isAttachmentLoading: boolean = false;
  activeTab: string = 'approvalRoute';
  totalAmountWords: string = '';
  displayedColumns: string[] = ['number', 'lineType', 'description', 'amount'];

  enableAction: boolean = false;
  enableInformation: boolean = false;
  enableDoa: boolean = false;
  enableNextApprover: boolean = false;

  enableForwardButton: boolean = false;
  selectedRequestOperation: RequestOperation = this.requestOperation.None;

  enableDefaultButtons: boolean = true;
  enableAdditionalButtons: boolean = false;

  requestCanBeClosed: boolean = false;
  requestCanBeCanceled: boolean = false;
  requestCanBeSetToReady: boolean = false;
  requestCanBeApproved: boolean = false;
  requestCanBeReturned: boolean = false;
  

  doa = "0";
  doaAmount: number = 0.0;
  doaLoading: boolean = false;
  amountToApprove: number = 0.0;
  doaMessage: string = "";
  doaType: string = "";
  nextApprover = "";
  nextApproverEmail = "";
  nextApproverName = "";

  finalApprover: boolean = false;
  AFE_CCOwner_NextApprover: string = "";
  nextApproverNumber: number = 0;
  intendedApproverEmail: string = "";
  intendedApproverName: string = "";
  requestCanBeSendToJde: boolean = false;

  confirmation: boolean = false;
  confirmationButtons: boolean = false;
  confirmationMessage: string = "";

  isAdmin: boolean = false;
  user: ILoggedInUser;

  enableRequest: boolean = false;
  isEnableRequestRadioButtonsAvailable: boolean = false;
  
  @ViewChild(RequestHistoryComponent) requestHistoryComponent: RequestHistoryComponent;

  constructor(
    private searchRequestService: SearchRequestService, 
    public dialogRef: MatDialogRef<RequestDetailsViewComponent>, 
    private fb: FormBuilder,
    private validator: SearchRequestValidator,
    private userService: LoggedInUserService,
    private personService: PersonService,
    private currencyService: CurrencyService,
    private nmaDoaService: NmaDoaService,
    @Inject(MAT_DIALOG_DATA) public data: {requestNumber: number}) {
      this.requestNumber = this.data.requestNumber;
  }

  ngOnInit(): void {
    this.userService.currentUser$.subscribe(data => {
      this.user = data; 
      this.isAdmin = data.adminRight;
    });
    this.getData(this.requestNumber);

    this.form = this.fb.group({
      person: new FormControl('', [this.validator.customPatternValidator({
        pattern: '^([a-zA-Z]+( {1,2}[a-zA-Z]+)?|[0-9]+|[a-zA-Z]+ {0,2}[a-zA-Z]*)$',
        msg: 'In Employee field, please enter name and surname or a number.'
      })]),
      comment: new FormControl('')
    });
  }

  getTotalAmountWords(data: IRequest): void {
    var currency = ""
    if(data.totalAmount.includes("NGN")){
      currency = "Naira"
    } else if(data.totalAmount.includes("USD")){
      currency = "Dollars"
    }
      
    this.totalAmountWords = toWords(data.totalAmountNumber);
    this.totalAmountWords = this.totalAmountWords + " " + currency;
  }

  getData(requestNumber): void {
    this.isLoading = true;    
    this.searchRequestService.getRequestDetails(requestNumber).subscribe(data => {  
      this.requestData = data;
      this.imprestDetails = data.imprestDetails;
      this.getTotalAmountWords(this.requestData)
      this.isLoading = false;
      this.checkButtons();
      this.enableInformation = false;
            
      // Load attachments if attachmentID exists
      if (data.attachmentID) {
        this.loadAttachments(data.attachmentID);
      }
    });

    this.searchRequestService.loadApprovalRouteData(requestNumber).subscribe(data => {      
      this.approvalRouteData = data;
      this.pendingApprovalRouteData = data.filter(x => x.action == "P");
      this.enableInformation = false;
    });    
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  cancelRequest(): void {
    const requestCancel: IRequestTerminate = {
      requestNumber: this.requestNumber,
      comment: this.form.get('comment').value,
      userEmail: this.user.userEmail,
      userName: this.user.userName,
      enteredByEmail: this.requestData.enteredByEmail
    };
    
    this.searchRequestService.cancelRequest(requestCancel).subscribe({
      next: () => {
        this.enableInformation = true;
        this.endInformation = "Request has been successfully canceled.";
        this.enableDefaultButtons = false
      },
      error: () => {
        this.enableInformation = true;
        this.endInformation = "Request canceled with errors."; // TODO handle errors from API
        this.enableDefaultButtons = false
      }});
  }

  closeRequest(): void {
    const requestClose: IRequestTerminate = {
      requestNumber: this.requestNumber,
      comment: this.form.get('comment').value,
      userEmail: this.user.userEmail,
      userName: this.user.userName,
      enteredByEmail: this.requestData.enteredByEmail
    };
    
    this.searchRequestService.closeRequest(requestClose).subscribe({
      next: () => {
        this.enableInformation = true;
        this.endInformation = "Request has been successfully closed.";
        this.enableDefaultButtons = false
      },
      error: () => {
        this.enableInformation = true;
        this.endInformation = "Request closed with errors."; // TODO handle errors from API
        this.enableDefaultButtons = false
      }});
  }

  requestReady(): void {
    const requestReady: IRequestReady = {
      requestNumber: this.requestNumber,
      userEmail: this.user.userEmail,
      userName: this.user.userName
    };
    
    this.searchRequestService.requestReady(requestReady).subscribe({
      next: () => {
        this.enableInformation = true;
        this.endInformation = "Request has been successfully set to ready.";
        this.enableDefaultButtons = false
      },
      error: () => {
        this.enableInformation = true;
        this.endInformation = "Request set to ready with errors."; // TODO handle errors from API
        this.enableDefaultButtons = false
      }});
  }

  sendRequestToJde(): void {
  const requestSendToJde: IRequestSendToJde = {
    requestNumber: this.requestNumber,
    userEmail: this.user.userEmail,
    userName: this.user.userName,
    modeCode: this.requestData.modeCode,
    howPaidCode: this.requestData.howPaidCode,
    employeeNo: this.requestData.employeeNo,
    totalAmount: this.requestData.totalAmountNumber,
    requestTypeDescription: this.requestData.requestType,
    requestType: this.requestData.requestTypeId,
    enteredByEmail: this.requestData.enteredByEmail,
    employeeEmail: this.requestData.employeeEmail,
    employeeName: this.requestData.employeeName,
    reconId: this.requestData.reconId,
    fromGO165: this.requestData.fromGO165,
    logOnName: this.user.logOnName
  };
  
  this.searchRequestService.requestSendToJde(requestSendToJde).subscribe({
    next: () => {
      this.enableInformation = true;
      this.endInformation = "Request has been successfully sent to JDE.";
      this.enableDefaultButtons = false
    },
    error: (error) => {
      console.error("Error sending request to JDE:", error);
      this.enableInformation = true;
      this.endInformation = "Request sent to JDE with errors."; // TODO handle errors from API
      this.enableDefaultButtons = false
    }});
}

  returnRequest(): void {
    const requestReturn: IRequestReturn = {
      requestNumber: this.requestNumber,
      requestStatus: Number(this.requestData.numericStatus),
      enteredByEmail: this.requestData.enteredByEmail,
      userEmail: this.user.userEmail,
      userName: this.user.userName,
      comment: this.form.get('comment').value,
    };
    
    this.searchRequestService.returnRequest(requestReturn).subscribe({
      next: () => {
        this.enableInformation = true;
        this.endInformation = "Request has been successfully returned.";
        this.enableDefaultButtons = false
      },
      error: () => {
        this.enableInformation = true;
        this.endInformation = "Request returned with errors."; // TODO handle errors from API
        this.enableDefaultButtons = false
      }});
  }

  approveRequest(): void {
    if(this.nextApprover !== ""){
      const [name, email] = this.nextApprover.split(' (');
      this.nextApproverEmail = email.slice(0, -1);
      this.nextApproverName = name;
    }

    if(!this.intendedApproverEmail.includes("@")) {
      this.intendedApproverEmail = this.pendingApprovalRouteData[0].intendedApproverEmail;
      this.intendedApproverName = this.pendingApprovalRouteData[0].intendedApproverName;
    }

    const requestApprove: IRequestApprove = {
      requestNumber: this.requestNumber,
      userEmail: this.user.userEmail,
      userName: this.user.userName,
      comment: this.form.get('comment').value,
      nextApproverEmail: this.nextApproverEmail,
      nextApproverName: this.nextApproverName,
      nextApproverNumber: this.nextApproverNumber,
      intendedApproverEmail: this.intendedApproverEmail,
      intendedApproverName: this.intendedApproverName,
      finalApprover: this.finalApprover,
    };
    
    this.searchRequestService.approveRequest(requestApprove).subscribe({
      next: (data) => {
        if(data.isSuccess){
          this.endInformation = "Request has been successfully approved.";
        }else{
          this.endInformation = data.error.description;
        }        
        this.enableInformation = true;
        this.enableDefaultButtons = false;
      },
      error: (error) => {
        console.error("Error approving request:", error);
        this.enableInformation = true;
        this.endInformation = "Request returned with errors.";
        this.enableDefaultButtons = false;
      }});
  }

  canRequestBeCanceled(): boolean {
    // If no pending approvals, request cannot be canceled
    if (this.pendingApprovalRouteData.length === 0) return false;
    if (this.requestData.status === requestStatusesMapping[RequestStatuses.Canceled]) return false;
    
    if (this.pendingApprovalRouteData[0].approverEmail !== this.user.userEmail &&
      this.pendingApprovalRouteData[0].intendedApproverEmail !== this.user.userEmail && 
      (this.user.userEmail === this.requestData.employeeEmail || this.user.userEmail === this.requestData.enteredByEmail || this.isAdmin)) {
        return true;
      }
    return false;
  }

  canRequestBeClosed(): boolean {
    if (this.requestData.status === requestStatusesMapping[RequestStatuses.Closed]) return false;
    if ((this.requestData.status === requestStatusesMapping[RequestStatuses.Approved] ||
      this.requestData.status === requestStatusesMapping[RequestStatuses.Reviewed]) &&
      (this.user.userRole === UserRole.ImprestAnalyst || this.user.userRole === UserRole.ImprestAnalystLocal || this.user.userRole === UserRole.ImprestAnalystForeign)) {
      return true;
    }
    return false
  }

  canRequestBeSetToReady(): boolean {
    const { status, howPaidCode, mode } = this.requestData;
    const { userRole } = this.user;
    
    if (status === requestStatusesMapping[RequestStatuses.Approved]) {
      if (howPaidCode === HowPaid.ByCash && 
        (userRole === UserRole.ImprestAnalyst || 
          (mode === Mode.Local && userRole === UserRole.ImprestAnalystLocal) || 
          (mode === Mode.Foreign && userRole === UserRole.ImprestAnalystForeign))) {
        return true;
      }
    }
    return false;
  }

  canRequestBeReturned(): boolean {
    const { status, howPaidCode, mode } = this.requestData;
    const { userRole } = this.user;

    if (status === requestStatusesMapping[RequestStatuses.Approved] || status === requestStatusesMapping[RequestStatuses.Reviewed]) {
      if (howPaidCode === HowPaid.ByCash && (userRole === UserRole.ImprestAnalyst || 
        (mode === Mode.Local && userRole === UserRole.ImprestAnalystLocal) ||
        (mode === Mode.Foreign && userRole === UserRole.ImprestAnalystForeign))) {
          return true;
      }
      if (howPaidCode === HowPaid.SalaryAccount && userRole === UserRole.BenefitsAnalyst) {
        return true;
      }
    }
    return false;
  } 

  public setApproveData(){
    if(this.user.userEmail.toLowerCase() === this.requestData.enteredByEmail?.toLowerCase() || this.user.userEmail.toLowerCase() === this.requestData.employeeEmail?.toLowerCase()){      
      this.requestCanBeApproved = false;
    }
    else{   
      this.setNextApprover();

      if (!this.finalApprover){
        this.doaLoading = false
        return
      } 

      this.calculateAmmountToApprove();  
      this.checkDoa();
      this.requestCanBeApproved = true;
    }       
  }

  async setNextApprover(){
    this.doaLoading= true
    var approverNumber = this.pendingApprovalRouteData[0].approverNumber
    var nextApprover = "";

    if(approverNumber < 5){
      nextApprover = this.requestData.approvers[approverNumber + 1];
    }

    if(nextApprover === undefined || nextApprover === null || nextApprover === ""){
      this.finalApprover = true; 
    }else{
      if(nextApprover.toLowerCase().includes("*SUP".toLowerCase())){
        this.enableNextApprover = true;
        this.AFE_CCOwner_NextApprover = "N"
        
        var person = await firstValueFrom(this.personService.searchPerson(null,null,this.requestData.employeeNo));
        if(person && person.length > 0 && person[0].reportsToEmail !== null){
          this.nextApproverName = person[0].reportsToName;
          this.nextApproverEmail = person[0].reportsToEmail;
          this.nextApprover = this.nextApproverName + " (" + this.nextApproverEmail + ")";
        }
      }
      if(nextApprover !="" && nextApprover != "*SUP"){
        this.enableNextApprover = true;
        this.nextApprover = nextApprover;
        this.AFE_CCOwner_NextApprover = "N"
      }
      this.nextApproverNumber = approverNumber + 1;
    } 

  }

  async calculateAmmountToApprove() {
    var totalAmount = this.requestData.totalAmountNumber;
        
    if(this.requestData.modeCode === "D"){
      var exRate = 1;
      if(this.requestData.imIsDollarToNairaEquivalentPayment){
        exRate = await firstValueFrom(this.currencyService.usdExchangeRate('NGN'))        
      }else{
        const entryDate = new Date(this.requestData.entryDate);
        var year = entryDate.getFullYear();
        var month = entryDate.getMonth();
        exRate = await firstValueFrom(this.currencyService.treasuryDefinedCurrencyConversionRateUsdAndNgn(year, month))     
      }

      if(exRate > 0){
        this.amountToApprove = totalAmount / exRate;
      }else{
        this.amountToApprove = 99999999999
      }
    }else{
      this.amountToApprove = totalAmount;
    }
  }

  async checkDoa(){
    var highestDOAAmount = 0;
    var doaOwnerEmail = "";
    var doaAmount;
    var doaOwnerEmployeeNumber;

    var personData = await firstValueFrom(this.personService.GetByEmail(this.pendingApprovalRouteData[0].intendedApproverEmail));

    doaOwnerEmployeeNumber = personData.id;
    doaOwnerEmail = personData.email;

    var doaData = await firstValueFrom(this.nmaDoaService.doaByType(doaOwnerEmployeeNumber, this.requestData.doaType));
    doaAmount = doaData;
    highestDOAAmount = doaAmount;

    if (highestDOAAmount < this.amountToApprove && this.user.userEmail !== doaOwnerEmail) {
      var userEmployeeNumber = (await firstValueFrom(this.personService.GetByEmail(this.user.userEmail))).id;
      
      doaAmount = await firstValueFrom(this.nmaDoaService.doaByType(userEmployeeNumber.toString(), this.requestData.doaType));
      
      if(doaAmount > highestDOAAmount){
        highestDOAAmount = doaAmount
        doaOwnerEmail = this.user.userEmail
      }
    }
    
    var doaFormatted = highestDOAAmount // use data pipe | currency
    var doaOwnerName = "";
    var doaOwnerData = await firstValueFrom(this.personService.GetByEmail(doaOwnerEmail));
    if (doaOwnerData === null){
      doaOwnerName = doaOwnerEmail;
    }
    else{
      doaOwnerName = doaOwnerData.fullName
    }

    this.intendedApproverEmail = doaOwnerEmail;
    this.intendedApproverName = doaOwnerName;
    this.nextApproverNumber = this.pendingApprovalRouteData[0].approverNumber;

    if(doaOwnerEmail !== this.user.userEmail){
      this.doa = doaFormatted.toString();
    }
    else{
      this.doa = doaFormatted + " (from " + doaOwnerName + ")"
    }

    if(highestDOAAmount < this.amountToApprove){
      this.doaMessage = "Your DOA is less than the amount for this eCash request so, after your approval, it" +
                            " needs to go to another approver with a higher DOA. Specify the next approver below."
      this.enableNextApprover = true
      this.finalApprover = false
      this.selectedRequestOperation = RequestOperation.Forward
    }
    else{
      this.doaMessage = "Your DOA is sufficient to approve this eCash request."
    }

    this.doaAmount = parseFloat(this.doa);
    this.doaLoading = false
    this.enableDoa = true
    this.finalApprover = true
  }  

  canRequestBeSendToJde(): boolean {
    const { status, howPaidCode, mode } = this.requestData;
    const { userRole } = this.user;

    if (status === requestStatusesMapping[RequestStatuses.SentToBank] || status === requestStatusesMapping[RequestStatuses.Reviewed]) {
      if (howPaidCode === HowPaid.ByCash && (userRole === UserRole.ImprestAnalyst || 
        (mode === Mode.Local && userRole === UserRole.ImprestAnalystLocal) ||
        (mode === Mode.Foreign && userRole === UserRole.ImprestAnalystForeign))) {
          return true;
      }
    }
    return false;
  }

  checkButtons(): void {
    // Cancel
    if (this.canRequestBeCanceled()) {
      this.requestCanBeCanceled = true;
    }

    // Close
    if (this.canRequestBeClosed()) {
      this.requestCanBeClosed = true;
    }

    // Ready
    if (this.canRequestBeSetToReady()) {
      this.requestCanBeSetToReady = true;
    }

    // Return
    if (this.canRequestBeReturned()) {
      this.requestCanBeReturned = true;
    }

    // Send to JDE
    if (this.canRequestBeSendToJde()) {
      this.requestCanBeSendToJde = true;
    }

    if(this.requestData.status == requestStatusesMapping[RequestStatuses.Canceled] && this.isAdmin){
      const oneWeek = 7 * 24 * 60 * 60 * 1000;
      const timeClosed = new Date(this.requestData.timeClosed).getTime();
      const currentTime = new Date().getTime();
      
      if (currentTime - timeClosed < oneWeek) {
        this.enableForwardButton = true;
        this.isEnableRequestRadioButtonsAvailable = true
        
        if(this.pendingApprovalRouteData && this.pendingApprovalRouteData.length > 0){
          this.form.patchValue({
            comment: this.pendingApprovalRouteData[0].intendedApproverName
          });
        }
      }
    }

    if(this.requestData.status == requestStatusesMapping[RequestStatuses.Entered] || this.requestData.status == requestStatusesMapping[RequestStatuses.Approving]){
      this.checkIfApprover();
    }
  }

  checkIfApprover(): void {   
    if(this.pendingApprovalRouteData && this.pendingApprovalRouteData.length == 0){
      if((this.requestData.status == requestStatusesMapping[RequestStatuses.Entered]
        ||this.requestData.status == requestStatusesMapping[RequestStatuses.Returned]
        ||this.requestData.status == requestStatusesMapping[RequestStatuses.Approving])
        && this.isAdmin) {
          this.enableForwardButton = true;
          
      }
      return;
    }

    var amIApproverCheck = this.isCurrentUserAnApprover(); 
    if(this.user.userEmail.toLowerCase() !== this.pendingApprovalRouteData[0].approverEmail?.toLowerCase()
      && this.user.userEmail.toLowerCase() !== this.pendingApprovalRouteData[0].intendedApproverEmail?.toLowerCase()){
      if(this.user.userEmail.toLowerCase() === this.requestData.employeeEmail?.toLowerCase()
        || this.user.userEmail.toLowerCase() === this.requestData.enteredByEmail?.toLowerCase()
        || amIApproverCheck
        || this.isAdmin) {
        this.enableForwardButton = true;
      }
      return;
    }
    this.enableForwardButton = true;
    
    this.setApproveData();
  }

  isCurrentUserAnApprover(): boolean {
    return this.approvalRouteData.some(element =>
      element.approverEmail?.toLowerCase() === this.user.userEmail.toLowerCase() || element.intendedApproverEmail?.toLowerCase() === this.user.userEmail.toLowerCase());
  }
    
  onSelectionChange(event: any): void {
    this.enableRequest = event.value;
  }

  proceedAction(): void {
    switch (this.selectedRequestOperation) {
      case RequestOperation.Forward:
        this.forwardRequest();
        break;
      case RequestOperation.Cancel:
        this.cancelRequest();
        break;
      case RequestOperation.Close:
        this.closeRequest();
        break;
      case RequestOperation.Ready:
        this.requestReady();
        break;
      case RequestOperation.Return:
        this.returnRequest();
        break;
      case RequestOperation.Approve:
        this.approveRequest();
        break;
      case RequestOperation.SendToJde:
        this.sendRequestToJde();
        break;
      default:
        console.warn('Unknown operation:', this.selectedRequestOperation);
        break;
    }
    this.enableAdditionalButtons = false;
    this.enableDefaultButtons = false;
  }

  forwardRequest(): void {
    const requestForward = {
      requestNumber: this.requestNumber,
      forwardTo: this.form.get('person').value,
      comment: this.form.get('comment').value,
      enableRequest: Boolean(this.enableRequest),
      user: this.user
    };

    this.searchRequestService.forwardRequest(requestForward).subscribe({
      next: () => {
        this.enableInformation = true;
        this.endInformation = "Request has been forwarded successfully.";
        this.enableDefaultButtons = false
      },
      error: () => {
        this.enableInformation = true;
        this.endInformation = "Failed to forward request.";
        this.enableDefaultButtons = false
      }});
  }

  startAction(operation: RequestOperation): void {
    this.selectedRequestOperation = operation;

    switch (operation) {
      case RequestOperation.Forward:
        this.label = "Forward to";
        this.placeholder = "Comment (inserted in notification e-mail)";
        break;
      case RequestOperation.Cancel:
        this.placeholder = "Reason for Canceling the Request";
        break;
      case RequestOperation.Close:
        this.placeholder = "Reason for Closing the Request";
        break;
      case RequestOperation.Ready:
        this.confirmation = true;
        this.confirmationMessage = "Confirm that this eCash request is ok and ready for processing.";
        break;
      case RequestOperation.Return:
        this.placeholder = "Reason for Return";
        break;
      case RequestOperation.SendToJde:
        this.confirmation = true;
        this.confirmationMessage = "Confirm that this eCash request is ok and ready for sending to JDE.";
        break;
        break;      
      case RequestOperation.Approve:
        if(this.pendingApprovalRouteData.length > 0 && this.pendingApprovalRouteData[0].afeCcOwner === "Y"){
          this.confirmation = true;
          this.confirmationButtons = true;
          this.confirmationMessage = "Are you responsible for the Cost Center/AFE being charged? If yes, please click “Okay”, if not, kindly click “Cancel” then forward to the appropriate person. Thank You";
        }
        else{
          this.placeholder = "Comment";
          this.label = "Next Approver";
        }
        break;
    }

    this.enableAction = true;
    this.enableAdditionalButtons = true;    
    this.enableDefaultButtons = false;
  }

  confirm(confirmed: boolean): void {
    this.confirmation = false;
    this.confirmationButtons = false;
    
    if (confirmed) {
      this.placeholder = "Comment";
      this.label = "Next Approver";
    }
    else{
      this.back();
    }
  }

  back(): void {
    this.disableAllActions();
    this.enableAdditionalButtons = false;
    this.enableDefaultButtons = true;
  }

  disableAllActions(): void {
    this.enableAction = false
    this.isEnableRequestRadioButtonsAvailable = false
  }

  onPersonSelected(person: IPerson): void {
    this.form.get('person').setValue(person);
  }

  onPersonClear(): void {
    this.form.get('person').setValue('');
  }

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
    if (tabName === "requestHistory" && this.historyDataLoaded === false) {
      this.historyDataLoaded = true;
      this.requestHistoryComponent.loadData();
    }
  }
  
  loadAttachments(attachmentId: string): void {
    this.isAttachmentLoading = true;

    this.searchRequestService.getAttachments(attachmentId).subscribe({
      next: (data) => {
        this.isAttachmentLoading = false;
        this.attachments = data;
      },
      error: (error) => {
        console.error("Error loading attachments:", error);
        this.isAttachmentLoading = false;
      }});
  }
  getFileNameOnly(fullPath: string): string {
    return fullPath.split('/').pop() || fullPath;
  }
  downloadAttachment(attachment: BlobModel): void {
    try {
      // Check if content is already a string or Uint8Array
      let base64String: string;
      
      if (typeof attachment.content === 'string') {
        // If it's already a string, it's probably Base64
        base64String = attachment.content;
      } else if (attachment.content instanceof Uint8Array) {
        // If it's Uint8Array, convert to string
        base64String = new TextDecoder().decode(attachment.content);
      } else {
        throw new Error('Unknown content type');
      }
      
      // Decode Base64 to binary data
      const binaryString = atob(base64String);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      
      const blob = new Blob([bytes], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.getFileNameOnly(attachment.fileName);
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading attachment:', error);
      // Fallback: try with original content
      const blob = new Blob([attachment.content], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.getFileNameOnly(attachment.fileName);
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
}
